import { render, staticRenderFns } from "./CustomModel.vue?vue&type=template&id=68343809&scoped=true&"
import script from "./CustomModel.vue?vue&type=script&lang=js&"
export * from "./CustomModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68343809",
  null
  
)

export default component.exports